import { Link as RouterLink } from 'react-router-dom';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, Breadcrumbs, Container, Link, Typography } from '@mui/material';

function PageBanner({ title, subtitle, breadcrumb = [] }) {
  return (
    <Box
      sx={{
        pt: { xs: 12, md: 13 },
        pb: { xs: 6, md: 7 },
        color: '#ffffff',
        background:
          'linear-gradient(135deg, rgba(74,14,143,1) 0%, rgba(26,5,51,1) 56%, rgba(13,1,32,1) 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'repeating-linear-gradient(135deg, rgba(201,168,76,0.07) 0px, rgba(201,168,76,0.07) 1px, transparent 1px, transparent 28px)',
        },
        borderBottom: '2px solid #c9a84c',
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Breadcrumbs separator={<ChevronRightRoundedIcon sx={{ color: '#c9a84c' }} />} sx={{ mb: 2 }}>
          {breadcrumb.map((item, index) => {
            const last = index === breadcrumb.length - 1;
            return last ? (
              <Typography key={item.path || item.label} sx={{ color: '#ffffff' }}>
                {item.label}
              </Typography>
            ) : (
              <Link
                key={item.path || item.label}
                component={RouterLink}
                to={item.path}
                underline="hover"
                sx={{ color: '#c9a84c' }}
              >
                {item.label}
              </Link>
            );
          })}
        </Breadcrumbs>
        <Typography variant="h1" sx={{ fontSize: { xs: '2.8rem', md: '4rem' }, mb: 1 }}>
          {title}
        </Typography>
        <Typography sx={{ maxWidth: 760, color: 'rgba(255,255,255,0.78)' }}>{subtitle}</Typography>
      </Container>
    </Box>
  );
}

export default PageBanner;
